<template>
  <div class="message-item__info-header">
    <div class="message-item__top-row">
      <p class="message-item__user-name" @click="showUserInfoHandler">
        <b>{{authorName}}</b>
        <b> ⋅ </b>
      </p>
      <timesince
        :timestamp="message.timestamp"
        type="chat"
        class="message-item__timestamp"
      />
    </div>
    <p v-if="pronouns" class="pronouns"> ({{pronouns}})</p>
  </div>
</template>

<script>
import Timesince from '@/components/sidebar/Timesince.vue';
export default {
  name:'ChatMessageNameHeader',
  components: {
    Timesince,
  },
  props: {
    message: Object,
    showUserInfo: Function
  },
  computed: {
    authorName() {
      return `${this.message.author.firstName || ''} ${this.message.author.lastName || ''}`
    },
    pronouns() {
      return this.message.author.pronouns || ''
    }
  },
  methods: {
    showUserInfoHandler() {
      if(this.showUserInfo) this.showUserInfo()
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@/scss/components/sidebar/chat_message_name_header.scss';
</style>
